
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40.485 21.21H13.185L7.873 32.38h43.594l-5.312-11.17h-5.67zm-1.11-7.98v5.73h-18v-5.73h18zm-20.22 5.73V12.9c0-1.05.85-1.9 1.9-1.9h18.65c1.05 0 1.9.85 1.9 1.9v6.06h5.26c.43 0 .82.25 1.01.64l6.37 13.4c.14.3.14.65 0 .96l-6.37 13.4c-.19.39-.58.64-1.01.64h-34.38c-.43 0-.82-.25-1.01-.64l-6.37-13.4c-.14-.3-.14-.65 0-.96l6.37-13.4c.18-.39.58-.64 1.01-.64h6.67zm-5.97 26.81h32.97l5.312-11.17H7.873l5.312 11.17z"}})])
          )
        }
      }
    